export const TIMESHEET_ENTRIES_LOAD_REQUESTED =
    'TIMESHEET_ENTRIES_LOAD_REQUESTED';
export const TIMESHEET_ENTRIES_LOAD_SUCCEEDED =
    'TIMESHEET_ENTRIES_LOAD_SUCCEEDED';
export const TIMESHEET_ENTRIES_LOAD_FAILED = 'TIMESHEET_ENTRIES_LOAD_FAILED';
export const TIMESHEET_ENTRIES_LOAD_CANCELED =
    'TIMESHEET_ENTRIES_LOAD_CANCELED';

export const TIMESHEET_ENTRY_UPDATE_REQUESTED =
    'TIMESHEET_ENTRY_UPDATE_REQUESTED';
export const TIMESHEET_ENTRY_UPDATE_SUCCEEDED =
    'TIMESHEET_ENTRY_UPDATE_SUCCEEDED';
export const TIMESHEET_ENTRY_UPDATE_FAILED = 'TIMESHEET_ENTRY_UPDATE_FAILED';

export const TIMESHEET_ENTRIES_APPROVE_REQUESTED =
    'TIMESHEET_ENTRIES_APPROVE_REQUESTED';
export const TIMESHEET_ENTRIES_APPROVE_SUCCEEDED =
    'TIMESHEET_ENTRIES_APPROVE_SUCCEEDED';
export const TIMESHEET_ENTRIES_APPROVE_FAILED =
    'TIMESHEET_ENTRIES_APPROVE_FAILED';

export const TIMESHEET_ENTRIES_DELETE_REQUESTED =
    'TIMESHEET_ENTRIES_DELETE_REQUESTED';
export const TIMESHEET_ENTRIES_DELETE_SUCCEEDED =
    'TIMESHEET_ENTRIES_DELETE_SUCCEEDED';
export const TIMESHEET_ENTRIES_DELETE_FAILED =
    'TIMESHEET_ENTRIES_DELETE_FAILED';

export const TIMESHEET_ENTRIES_SET = 'TIMESHEET_ENTRIES_SET';
